import React, { useState } from "react";
import { Spin } from "antd";
import { useContext } from "react";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
import Header from "./Header";
import WelcomeCard from "./WelcomeCard";
import StatsCards from "./StatsCard";
import PerformanceTable from "./PerformanceTable";
import { LoadingOutlined } from "@ant-design/icons";
import { styles } from "./Style";
import TrainingTable from "./TrainingTable";
import useManagerDashboard from  "PlatForms/OrgLMS/Hooks/ManagerHooks/useManagerDashboard";
const ManagerLandingPage = () => {
  const { isProfileComplete } = useContext(ProfileContext);
  const isBlocked = !isProfileComplete;
  const { dashboardData, loading, error } = useManagerDashboard();
  const [darkMode, setDarkMode] = useState(false);
  const spinnerIcon = <LoadingOutlined style={{ fontSize: 48, color: "#1890ff" }} spin />;
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
          backgroundColor: darkMode ? "#141414" : "#fff",
          transition: "background-color 0.3s ease",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <Spin
            indicator={spinnerIcon}
            tip="Loading your dashboard, please wait..."
            size="large"
            style={{
              display: "inline-block",
              marginBottom: 16,
            }}
          />
          <div
            style={{
              fontSize: "18px",
              color: darkMode ? "#fff" : "#000",
              fontWeight: 600,
              marginTop: "20px",
            }}
          >
            Please wait while we load your data.
          </div>
        </div>
      </div>
    );
  }
  if (error) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
          backgroundColor: darkMode ? "#141414" : "#f0f2f5",
          color: darkMode ? "#fff" : "#000",
          fontSize: 18,
          fontWeight: 500,
        }}
      >
        ⚠️ Error: {error}
      </div>
    );
  }
  if (!dashboardData) {
    return <div>No data available</div>;
  }
  const toggleDarkMode = () => setDarkMode(!darkMode);
  const currentStyles = styles(darkMode);
  return (
    <div style={{
      ...currentStyles.container,
      padding: '16px 24px',
      minHeight: '100vh',
      maxWidth: '100vw',
      overflowX: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      gap: '16px'
    }}>
      <Header darkMode={darkMode} toggleDarkMode={toggleDarkMode} styles={currentStyles} />
      <WelcomeCard
        styles={currentStyles}
        managerData={dashboardData.manager}
        lastLogin={dashboardData.lastLogin}
      />
      <StatsCards
        styles={{
          ...currentStyles,
          card: {
            ...currentStyles.card,
            width: '100%',
            margin: 0
          }
        }}
        statsCardData={dashboardData}
      />
      <PerformanceTable
        styles={currentStyles}
        learners={dashboardData.employees}
        darkMode={darkMode}
      />
      <TrainingTable
        styles={currentStyles}
        trainings={dashboardData.trainings}
        darkMode={darkMode}
      />
    </div>
  );
};
export default ManagerLandingPage;
